module.exports = __webpack_public_path__ + "img/180.4dd7717c.jpg";